export default __webpack_public_path__ + "static/footer-icon-el-ad7a518275d8b1d343a8bbf9a2ae5643.jpeg";